import { Auth } from "aws-amplify";

export const getUser = async () => {
    try {
        const user = await Auth.currentAuthenticatedUser(); // Await the promise
        return user.username; // Return the username
    } catch (err) {
        console.log("Error in getUser: ", err);
        return null; // Handle the case where user is not authenticated
    }
};

// create_solution_generator_plan
export const createSolutionGeneratorPlan = async (formData) => {
    const user = await getUser();
    formData.append("username", user);

    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/create_solution_generator_plan`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error in createSolutionGeneratorPlan: ", error);
        throw error;
    }
};

// add plan to project
export const addPlanToProject = async (formData) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/add_plan_to_project`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error in addPlanToProject: ", error);
        throw error;
    }
};

// update plan
export const updatePlanAPI = async (formData) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_FASTAPI_URL}/update_plan`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error in updatePlanAPI: ", error);
        throw error;
    }
};
